export const appBaseURL = "/bazaar/"

export const appKeepalive = false

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"property":"og:image:type","content":"image/png"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:image","content":"/bazaar/xsolla/og_1200x630.jpg"},{"property":"og:image:width","content":"630"},{"property":"og:image","content":"/bazaar/xsolla/og_630x630.jpg"},{"name":"twitter:image","content":"/bazaar/xsolla/og_1200x630.jpg"},{"property":"og:image:alt","content":"Xsolla ZK NFT Bazaar — Hassle-Free NFT Marketplace for Gamers"},{"name":"theme-color","content":"#77FE53"},{"name":"generator","content":"Xsolla ZK NFT Bazaar — Hassle-Free NFT Marketplace for Gamers"},{"property":"og:title","content":"Xsolla ZK NFT Bazaar — Hassle-Free NFT Marketplace for Gamers"},{"property":"og:site_name","content":"Xsolla ZK NFT Bazaar"},{"property":"og:type","content":"website"},{"property":"og:description","content":"Xsolla ZK NFT Bazaar is a user-friendly NFT marketplace for gamers. Enjoy simple transactions and seamless integrations with your favorite gaming platforms."},{"name":"author","content":"Xsolla ZK NFT Bazaar"},{"name":"robots","content":"index, follow"},{"name":"keywords","content":"gamer nft, trading nft, nft marketplace for gamers, gaming nft, game-integrated nft"},{"name":"description","content":"Xsolla ZK NFT Bazaar is a user-friendly NFT marketplace for gamers. Enjoy simple transactions and seamless integrations with your favorite gaming platforms."},{"name":"twitter:title","content":"Xsolla ZK NFT Bazaar — Hassle-Free NFT Marketplace for Gamers"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:creator","content":"Xsolla ZK NFT Bazaar"},{"name":"twitter:description","content":"Xsolla ZK NFT Bazaar is a user-friendly NFT marketplace for gamers. Enjoy simple transactions and seamless integrations with your favorite gaming platforms."}],"link":[{"rel":"icon","type":"image/x-icon","sizes":"16x16","href":"/bazaar/xsolla/favicon_16x16.ico"},{"rel":"icon","type":"image/x-icon","sizes":"32x32","href":"/bazaar/xsolla/favicon_32x32.ico"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/bazaar/xsolla/favicon_16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/bazaar/xsolla/favicon_32x32.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/bazaar/xsolla/192x192.png"},{"rel":"icon","type":"image/png","sizes":"512x512","href":"/bazaar/xsolla/512x512.png"},{"rel":"icon","type":"image/svg+xml","href":"/bazaar/xsolla/favicon_SVG.svg"},{"rel":"mask-icon","href":"/bazaar/xsolla/dark.svg","color":"#151518"},{"rel":"mask-icon","href":"/bazaar/xsolla/light.svg","color":"#77FE53"},{"rel":"icon","href":"/bazaar/xsolla/favicon_32x32_dark.ico","media":"(prefers-color-scheme: dark)"},{"rel":"icon","href":"/bazaar/xsolla/favicon_32x32_dark.png","media":"(prefers-color-scheme: dark)"},{"rel":"apple-touch-icon","sizes":"57x57","href":"/bazaar/xsolla/apple-touch-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"/bazaar/xsolla/apple-touch-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"/bazaar/xsolla/apple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"/bazaar/xsolla/apple-touch-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/bazaar/xsolla/apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/bazaar/xsolla/apple-touch-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/bazaar/xsolla/apple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/bazaar/xsolla/apple-touch-icon-180x180.png"},{"rel":"msapplication-square150x150logo","content":"/bazaar/xsolla/150x150.png"},{"rel":"msapplication-wide310x150logo","content":"/bazaar/xsolla/310x150.png"},{"rel":"msapplication-square310x310logo","content":"/bazaar/xsolla/310x310.png"},{"rel":"apple-touch-startup-image","href":"/bazaar/xsolla/320x480.png"},{"rel":"apple-touch-startup-image","href":"/bazaar/xsolla/640x960.png"},{"rel":"apple-touch-startup-image","href":"/bazaar/xsolla/750x1334.png"},{"rel":"apple-touch-startup-image","href":"/bazaar/xsolla/1242x2208.png"},{"rel":"apple-touch-startup-image","href":"/bazaar/xsolla/1536x2048.png"},{"rel":"apple-touch-startup-image","href":"/bazaar/xsolla/2048x2732.png"},{"rel":"canonical","href":"https://x.la/bazaar"},{"rel":"preconnect","href":"https://x.la/bazaar"},{"rel":"dns-prefetch","href":"https://x.la/bazaar"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1","htmlAttrs":{"lang":"en"},"title":"Xsolla ZK NFT Bazaar — Hassle-Free NFT Marketplace for Gamers"}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"prefetch":true,"prefetchOn":{"interaction":true,"visibility":true},"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false